import React from 'react';
import Carousel from './Carousel';

import { splitData } from '../../helpers/helper';

const ReviewItem = ({ title, description }) => {
  return (
    <div className="review-item-container">
      <p className="review-item-title">{title}</p>
      <span className="review-item-description">{description}</span>
    </div>
  );
};

const MobileReviews = ({ data }) => {
  if (data.length === 0) {
    return null;
  }

  const modifiedData = splitData(data, 2);

  return (
    <Carousel className="mobile-carousel">
      {modifiedData.map(group => {
        return (
          <div key={group} className="mobile-reviews-content">
            {group.map((item, index) => {
              return (
                <ReviewItem
                  key={`${item.name}-${index}`}
                  title={item.name}
                  description={item.feedback}
                />
              );
            })}
          </div>
        );
      })}
    </Carousel>
  );
};

const DesktopReviews = ({ data }) => {
  return (
    <div className="desktop-reviews-content">
      {data.map((item, index) => {
        return (
          <ReviewItem
            key={`${item.name}-${index}`}
            title={item.name}
            description={item.feedback}
          />
        );
      })}
    </div>
  );
};

const Reviews = ({ reviews = [] }) => {
  return reviews && reviews.length ? (
    <section
      className={`reviews-container ${
        reviews.length > 0 ? 'full-height-reviews' : ''
      }`}>
      <p className="reviews-heading-text">Student Reviews</p>

      <MobileReviews data={reviews} />
      <DesktopReviews data={reviews} />
    </section>
  ) : null;
};

export default Reviews;



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/Reviews.js